import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {LaunchDialogService} from '@spartacus/storefront';

import {AimoRoutingService} from '../../../cms-structure/routing/aimo-routing.service';
import {AimoCart, AimoOrderEntry} from '../../../model/cart.model';
import {AimoActiveCartService} from '../../../service/cart/aimo-active-cart.service';
import {AimoGTMProductAttributes} from '../../../service/gtm/aimo-gtm.model';
import {AimoProductModalService} from '../../../service/product/aimo-product-modal.service';
import {AimoCartEntryDialogData, ITEM_MESSAGES} from '../../cart-details/aimo-cart-layout.config';
import {AimoCurrentProductService} from "../../../service/product/aimo-current-product.service";
import {Observable} from "rxjs";
import {AimoAssortmentService, LabelSuffix} from "../../../service/product/aimo-assortment.service";

@Component({
    selector: 'aimo-cart-item',
    templateUrl: './aimo-cart-item.component.html',
    standalone: false
})
export class AimoCartItemComponent implements OnInit {
    @Input() cart: AimoCart;
    @Input() readonly = false;
    @Input() gtmProductAttributes?: AimoGTMProductAttributes;
    @Input() alreadyOrdered = false;
    entry: AimoOrderEntry;

    numberOfMessages: number;
    myAssortmentLabelSuffix$: Observable<LabelSuffix>;
    addToCartForm: UntypedFormGroup;
    showTrashSpinner = false;

    constructor(
        protected activeCartService: AimoActiveCartService,
        protected currentProductService: AimoCurrentProductService,
        protected launchDialogService: LaunchDialogService,
        protected productModalService: AimoProductModalService,
        protected aimoRoutingService: AimoRoutingService,
        protected assortmentService: AimoAssortmentService,
    ) {
    }

    ngOnInit(): void {
        this.initForm();
        this.numberOfMessages = this.getNumberOfMessages(this.entry);
        this.myAssortmentLabelSuffix$ = this.assortmentService.getMyAssortmentLabelSuffix();
    }

    private initForm() {
        if (this.entry) {
            if (this.addToCartForm) {
                this.addToCartForm?.controls.quantity.setValue(this.entry.quantity);
            } else {
                this.addToCartForm = new UntypedFormGroup({
                    quantity: new UntypedFormControl(this.entry.quantity, {updateOn: 'blur'}),
                });
            }
        }
        this.showTrashSpinner = false;
    }

    @Input() set aimoEntry(e: AimoOrderEntry) {
        this.entry = e;
        this.initForm();
    }

    deleteEntry(entry: AimoOrderEntry): void {
        this.showTrashSpinner = true;
        this.activeCartService.removeAimoEntry(entry, null, this.gtmProductAttributes);
    }

    changeQuantity(): void {
        const quantity = this.addToCartForm.get('quantity')?.value;
        this.activeCartService.updateAimoEntry(
            {
                entryNumber: this.entry.entryNumber,
                quantity,
                product: {code: this.entry.product.code},
                gtmParams: {...this.entry.gtmParams}
            },
            null,
            this.gtmProductAttributes,
        );
    }

    openProductModal(sourceId: string): void {
        this.productModalService.openProductModal(
            this.entry.product.code,
            this.gtmProductAttributes,
            null,
            null,
            null,
            sourceId,
        );
    }

    openEntryMessagesModal(entry: AimoOrderEntry): void {
        this.launchDialogService.closeDialog(null);
        this.launchDialogService.openDialogAndSubscribe(ITEM_MESSAGES, undefined, {
            entry,
        } as AimoCartEntryDialogData);
    }

    private getNumberOfMessages(entry: AimoOrderEntry): number {
        return [
            entry.messageToCustomer !== undefined && entry.messageToCustomer !== '',
            entry.messageToPickup !== undefined && entry.messageToPickup !== '',
        ].filter(Boolean).length;
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }
}
